import { DefaultCategorical, BRAND_KIT_PALETTE_ID, getDeprecatedDefaultPalettes } from './palettes';
import { mapOrderedEntries } from '../../../shared/lib/utils';
export const getColorPalette = (colorOption, brandKitPalettes, palettes = getDeprecatedDefaultPalettes('getColorPalette-default'), fallback = DefaultCategorical) => {
  const {
    paletteId,
    brandKitId
  } = colorOption;
  const useBrandKitColorPalette = brandKitPalettes && brandKitPalettes.size > 0 && paletteId === BRAND_KIT_PALETTE_ID;
  const palette = (useBrandKitColorPalette && brandKitId ? brandKitPalettes.get(brandKitId) : palettes === null || palettes === void 0 ? void 0 : palettes.get(paletteId)) || fallback;
  return palette;
};

/**
 * @returns assignments
 */
export const autoAssignDiscreteValues = (keys, values) => {
  const selectValueByIndex = index => values.get(index % values.size);
  return mapOrderedEntries(keys.toOrderedMap(), keyValueTuple => {
    const [index, bucketKey] = keyValueTuple;
    return [bucketKey, selectValueByIndex(index)];
  });
};

/**
 * @returns assignments, attempting to not reuse values that have already been assigned
 */
export const autoAssignDiscreteValuesWithMinimalRepetition = (keys, values, assignments) => {
  let unassignedValues = values;
  return mapOrderedEntries(keys.toOrderedMap(), ([__, bucketKey]) => {
    if (assignments.has(bucketKey)) {
      return [bucketKey, assignments.get(bucketKey)];
    } else {
      const value = unassignedValues.first();
      unassignedValues = unassignedValues.shift();
      return [bucketKey, value];
    }
  });
};